/* eslint-disable no-throw-literal */
import { fork, all, takeLatest, put, select } from "redux-saga/effects";
import * as types from "~/store/partnerUser/types";
import * as userTypes from "~/store/user/userType";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";
import { openToast } from "~/components/common/molecules/ToastNotification";
import axios from "axios";
import { get } from "lodash";

function* requestCreatePartnerUser({ id }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const response = yield client.createUserMomoByToken(
      { momoid: id },
      { partnerid: AppId, platform }
    );
    const { token } = response.data;
    const userInfo = { ...response.data };

    yield put({ type: userTypes.GET_USER_INFO_BY_CODE_SUCCESS, userInfo });
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    window.localStorage.setItem("jwt", token);
  } catch (error) {
    console.log(error);
    openToast("Có lỗi xảy ra.", "error");
  }
}

function* watchRequestCreatePartnerUser() {
  yield takeLatest(types.CREATE_PARTNER_USER, requestCreatePartnerUser);
}

export default function* root() {
  yield all([fork(watchRequestCreatePartnerUser)]);
}
